import { useState, useEffect } from 'react';
import PurchaseHeader from './purchase-header.jsx';
import PurchasePage from './purchase-page.jsx';
import PurchasePaymentPage from './purchasePayment-page.jsx';
import "../../../styles/Auth/purchase.css";
const Purchase = () => {
    const [filters, setFilters] = useState({});
    const handleApplyFilters = (newFilters) => {
        setFilters(newFilters);
    };
    return (
        <div className="purchase-layout">
            <div className="purchase-content">
                {/* <main className="purchase-main">
                    <PurchaseHeader onApplyFilters={handleApplyFilters} />
                </main> */}
                <div className="purchase-body">
                    <PurchasePage filters={filters} />
                </div>
            </div>
        </div>
    );
};

export default Purchase;